function googleCalendarAuthRules(app) {
  return {

    // ドメイン  チェック  ・桁数チェック  ・必須チェック  ・型チェック
    domain: [
      {
        required: true,
        trigger: 'blur',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.tenant.googleAuth.domain')
        })
      },
      {
        max: 256,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.tenant.googleAuth.domain'),
          length: 256
        })
      },
    ],

    // クライアントID  チェック  ・桁数チェック  ・必須チェック  ・型チェック
    clientId: [
      {
        required: true,
        trigger: 'blur',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.tenant.googleAuth.clientId')
        })
      },
      {
        max: 256,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.tenant.googleAuth.clientId'),
          length: 256
        })
      },
    ],

    // シークレットキー  チェック  ・桁数チェック  ・必須チェック  ・型チェック
    secretKey: [
      {
        required: true,
        trigger: 'blur',
        message: app.$t('message.common.validation.required', {
          field: app.$t('label.system.tenant.googleAuth.secretKey')
        })
      },
      {
        max: 3000,
        trigger: 'blur',
        message: app.$t('message.common.validation.max', {
          field: app.$t('label.system.tenant.googleAuth.secretKey'),
          length: 3000
        })
      },
    ],

  }
}
export default {
  googleCalendarAuthRules: googleCalendarAuthRules
}
